module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-menus"
  }, [_c('ul', _vm._l((_vm.menuList), function(childMenu, key, childIndex) {
    return _c('li', {
      staticClass: "childMenu"
    }, [_c('router-link', {
      attrs: {
        "to": childMenu.to,
        "from": childMenu.to
      }
    }, [_vm._v(_vm._s(childMenu.text))])], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f00eba92","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus.vue
// module id = 3261
// module chunks = 1